import { render, staticRenderFns } from "./list.vue?vue&type=template&id=68027c6b&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=68027c6b&prod&scoped=true&lang=less&"
import style1 from "./list.vue?vue&type=style&index=1&id=68027c6b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68027c6b",
  null
  
)

export default component.exports